<script>
    import { Notebook } from '../controller.js'

    export let notebook_id = null

    let notebook = null
    if (notebook_id !== null) {
        notebook = Notebook.load(notebook_id)
    }
</script>


<nav>
    <ul>
        <li><a href="/">Home</a></li>
        {#if notebook !== null}
            <li><a href="/notebook/{notebook.id}">Notebook: {notebook.name}</a></li>
            <li><a href="/notebook/{notebook.id}/new_entry">New Entry</a></li>
        {:else}
            <li><a href="/new_notebook">New Notebook</a></li>
        {/if}
        <li><a href="/import_export">Import/Export</a></li>
        <li><a href="/screen">DM Screen</a></li>
    </ul>
</nav>

<style>
    nav {
        padding-bottom: 20px;
    }
    nav ul {
        list-style: none;
        padding: 0;
        margin: 0;
    }

    nav ul li {
        display: inline;
        padding: 5px;
    }
</style>
